import { useQuery } from '@tanstack/react-query';

import useUrl from '~/common/hooks/useUrl';
import { typedApiClient } from '~/common/util/api-client';

export const keys = {
  all: ['singleAssetInformation'],
  forAsset: (assetId: number) => [...keys.all, assetId],
};
export default function useSingleAsset(assetId: number) {
  const { obfuscatedLoanIdentifier } = useUrl();

  return useQuery({
    queryKey: keys.forAsset(assetId),
    async queryFn() {
      const { data } =
        await typedApiClient.v1.assetsInformationGetSingleAssetInformation({
          obfuscatedLoanIdentifier,
          assetId,
        });
      return data;
    },
  });
}
